module.exports = __webpack_public_path__ + "assets/finesse-f4e3ff.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/solutions/finesse/finesse.jpg
 ** module id = 105
 ** module chunks = 0
 **/